import { domToReact } from 'html-react-parser';

import { parserOptions } from '@commons/components/RichText';
import type { Template } from '@commons/components/RichText/templates';
import Flex from '@commons/containers/Flex';

import styles from './ImageAndTextList.module.scss';

/**
 * Image and Text / List CKEditor template.
 *
 * @param nodes - An array of DOM nodes to render.
 *
 * @returns A rendered React component.
 */

const ImageAndTextListTemplate: Template = ({ nodes }) => (
  <Flex
    gap="md"
    width={12}
    justify="space-between"
    direction={{ xs: 'column', md: 'row' }}
    className={styles.template}
  >
    {domToReact(nodes, parserOptions)}
  </Flex>
);

export default ImageAndTextListTemplate;
